module.exports = __webpack_public_path__ + "static/media/eis-logo-3.36489f63.ico";